export const DOCUMENT_TYPE_COLLECTION_AREA = 'collection-area';
